import React from "react";

const Restaurantsubtract = props => {
  return (
    <button className="btn btn-primary" onClick={props.subtract}>
      Subtract
    </button>
  );
};

export default Restaurantsubtract;
